import { LOAN_TYPE_AGRI_PROPERTY, LOAN_TYPE_BUSINESS, LOAN_TYPE_HOME } from "@/lib/constants";
import { useFormDataStore } from "@/components/context/useFormContext";
import { BusinessLoanDetails } from "@/components/quickForm/parts/business/loanDetailsStep";
import { DefaultLoanDetails } from "@/components/quickForm/parts/default/loanDetailsStep";
import { MortgageLoanDetails } from "@/components/quickForm/parts/mortgage/loanPurposeStep";

export const LoanDetails = () => {
	const { formValues } = useFormDataStore();

	return (
		<div className="jF-space-y-2">
			{formValues.loanType !== LOAN_TYPE_BUSINESS ? (
				<>
					{formValues.loanType === LOAN_TYPE_AGRI_PROPERTY ||
					formValues.loanType === LOAN_TYPE_HOME ? (
						<>
							{/* Agri Property Loan and Home Loan Types*/}
							<MortgageLoanDetails />
						</>
					) : (
						<>
							{/* Other Loan Types*/}
							<DefaultLoanDetails />
						</>
					)}
				</>
			) : (
				<>
					{/* Business Loan */}
					<BusinessLoanDetails />
				</>
			)}
		</div>
	);
};
